<p-toast
  [key]="toastKey.systemToast"
  [life]="3000"
  [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'500ms'"
  [hideTransitionOptions]="'500ms'"
  position="top-right"
>
  <ng-template
    let-message
    [pTemplate]="'message'"
  >
    <div class="body d-flex align-items-center">
      <div class="icon-container">
        <i
          class="icon pi"
          [ngClass]="{
            'pi-bell': message.severity === ToastSeverity.info,
            'pi-check-circle': message.severity === ToastSeverity.success,
            'pi-info-circle': message.severity === ToastSeverity.warn,
            'pi-times-circle': message.severity === ToastSeverity.error
          }"
        ></i>
      </div>
      <div class="content">
        <div class="description">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
